import React, { useEffect, useRef, useState } from "react";
import SignaturePad from "react-signature-canvas";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import logo from "../assets/servimaxlogo.jpg";
import Capture from "./Capture";
import Spinner from "./Spinner";
import Information from "./Information";

function mergeImages(base64Image1, base64Image2) {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    const image1 = new Image();
    const image2 = new Image();
    image1.onload = () => {
      canvas.width = image1.width + image2.width;
      canvas.height = Math.max(image1.height, image2.height);

      context.drawImage(image1, 0, 0);
      context.drawImage(image2, image1.width, 0);

      const mergedImage = canvas.toDataURL();
      resolve(mergedImage);
    };
    image1.onerror = reject;
    image2.onerror = reject;

    image1.src = base64Image1;
    image2.src = base64Image2;
  });
}

const Form = ({ customer, setLoading, loading }) => {
  const navigate = useNavigate();
  const sigCanvas = useRef(null);
  const [state, setState] = useState("OBVERSE");
  const [signatureImg, setSignatureImg] = useState(null);
  const [imageIdentification, setImageIdentification] = useState({
    selfie: {},
    obverse: {},
    reverse: {},
  });
  const webcamRef = React.useRef(null);

  useEffect(() => {
    setState("SIGNATURE");
  }, []);

  useEffect(() => {
    if (sigCanvas.current && signatureImg) {
      // Carga la firma si existe
      sigCanvas.current.fromDataURL(signatureImg);
    }
  }, [signatureImg]);

  //   const clean = () => sigCanvas.current.clear();
  const clean = () => {
    if (sigCanvas.current) {
      sigCanvas.current.clear();
      setSignatureImg(null); // También borra el estado
    }
  };

  const handleEnd = () => {
    // Guarda la firma como Data URL
    if (sigCanvas.current) {
      setSignatureImg(sigCanvas.current.toDataURL());
    }
  };

  const save = () => {
    saveApi().then();
  };
  const saveApi = async () => {
    try {
      const url = `${process.env.REACT_APP_SERVIMAX_API_URL}/cliente/GuardarCapturaFirma`;
      let signature = {};
      signature.idCliente = customer.idCliente;
      signature.idCaptura = customer.idCapturaFirma;
      signature.token = customer.token;
      signature.firma = signatureImg.split(";base64,")[1];
      signature.selfie = imageIdentification.selfie.photo.split(";base64,")[1];
      mergeImages(
        imageIdentification.obverse.photo,
        imageIdentification.reverse.photo
      )
        .then(async (result) => {
          signature.cedula = result.split(";base64,")[1];
          const request = await axios.post(url, signature);
          navigate("/success");
        })
        .catch((error) => {
          console.log("Error merging images:", error);
        });
    } catch (error) {
      console.error(error);
      navigate("/");
    }
  };
  const nextState = (state) => {
    if (state === "INFORMATION") {
      const sig = sigCanvas.current.getTrimmedCanvas().toDataURL();
      setSignatureImg(sig);
      //console.log(sig);
      
    }
    setLoading(true);
    setState(state);
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  };
  const getState = () => {
    if (loading) {
      return <Spinner />;
    }
    if (state === "INFORMATION") {
      return <Information nextState={nextState} />;
    }
    if (state === "SIGNATURE") {
      return <GetSignature />;
    }
    if (state === "SELFIE") {
      return (
        <Capture
          state={state}
          imageIdentification={imageIdentification}
          setImageIdentification={setImageIdentification}
          webcamRef={webcamRef}
          nextState={nextState}
        />
      );
    }
    if (state === "OBVERSE") {
      return (
        <Capture
          state={state}
          imageIdentification={imageIdentification}
          setImageIdentification={setImageIdentification}
          webcamRef={webcamRef}
          nextState={nextState}
        />
      );
    }
    if (state === "REVERSE") {
      return (
        <Capture
          state={state}
          imageIdentification={imageIdentification}
          setImageIdentification={setImageIdentification}
          webcamRef={webcamRef}
          nextState={nextState}
          save={save}
        />
      );
    }
    return <div>Error</div>;
  };

  const GetSignature = () => {
    // Lógica para deshabilitar el redimensionamiento automático y forzar la recarga
    useEffect(() => {
      if (!sigCanvas.current) return;

      const pad = sigCanvas.current;

      if (pad.sigPad) {
        pad.sigPad._handleResize = () => {};
      }
      const handleResize = () => {
        setTimeout(() => {
          if (pad && signatureImg) {
            pad.fromDataURL(signatureImg);
          }
        }, 30);
      };
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, [signatureImg]);

    return (
      <div className="card">
        <div className="card-header" style={{ background: "red" }} />
        <img src={logo} alt="" />
        <div className="text-center">
          <label>Tú firma digital aquí</label>
          <div
            onTouchEnd={handleEnd}
            onMouseUp={handleEnd}
            style={{ touchAction: "none" }}
          >
            <SignaturePad
              ref={sigCanvas}
              canvasProps={{ className: "signature" }}
            />
          </div>
          <div className="px-6">
            <button className="btn btn-danger follow m-1" onClick={clean}>
              Limpiar
            </button>
            <button
              className="btn btn-secondary follow m-1"
              onClick={() => nextState("INFORMATION")}
            >
              Siguiente
            </button>
          </div>
        </div>
      </div>
    );
  };

  return getState();
};
export default Form;
